export const licencesConstants = {
    LICENCES_LOADING: "licences_loading",
    LICENCES_LOADED: "licences_loaded",
    LICENCES_ERROR: "licences_error",
}